import { siteDetails as text } from "@modules/locales/default.js"
import { SiteSettingsSection } from "../settings/constants"

export const SiteDetailsTab = {
  Builds: `builds`,
  Settings: `settings`,
  Deploys: "deploys",
  CmsPreview: `cmsPreview`,
  DataLayer: `content-hub`,
  Production: `production`,
  PullRequests: `pullRequests`,
}

export const tabsConfig = {
  [SiteDetailsTab.Settings]: {
    tab: SiteDetailsTab.Settings,
    label: text.headers.settings,
    hasSections: true,
    initialSection: SiteSettingsSection.General,
  },
  [SiteDetailsTab.Deploys]: {
    tab: SiteDetailsTab.Deploys,
    label: text.builds,
    hasSections: false,
  },
  [SiteDetailsTab.CmsPreview]: {
    tab: SiteDetailsTab.CmsPreview,
    label: text.previews,
    hasSections: false,
  },
  [SiteDetailsTab.DataLayer]: {
    tab: SiteDetailsTab.DataLayer,
    label: text.headers.dataLayer,
    hasSections: false,
    isNew: true,
  },
  [SiteDetailsTab.Production]: {
    tab: SiteDetailsTab.Deploys,
    label: text.headers.production,
    hasSections: false,
  },
  [SiteDetailsTab.PullRequests]: {
    tab: SiteDetailsTab.PullRequests,
    label: text.headers.pullRequests,
    hasSections: false,
  },
}
